import { AsPlaats } from "./as-plaats";

export class Traject {
  id: number;
  asPlaatsen: AsPlaats[];
}
